var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Main',[_c('div',{staticClass:"main user",attrs:{"slot":"main"},slot:"main"},[_c('div',{staticClass:"bank_title"},[_c('Header',{attrs:{"data":_vm.headerInfo}})],1),_c('div',{staticClass:"content"},[_vm._v(" 正在开发中 ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }